import React from 'react';
import { ButtonTypes } from "../types/campaigns";
import Link from "next/link";

const HeaderButtons = ({ buttons }: { buttons: ButtonTypes[] }) => {
	return (
		<div className="buttons">
			{buttons.map((button: ButtonTypes, i) => {
				const isUrl = button.type === "button" && button.buttonLink.type.toLowerCase() === "url";
				const isEntry = button.type === "button" && button.buttonLink.type === "Entry";
				const isBrochure = button.type === "brochure";

				if (isEntry) {
					return (
						<Link href={`/${button.buttonLink.uri}`} key={i}>
							<a
								target={button.buttonLink.target}
								title={button.buttonLink.text}
								className={`waves-effect waves-light btn-large ${button.colour != null && button.colour === 'white' ? 'bbwhite' : 'bbred'}`}>
								{button.buttonLink.text}
							</a>
						</Link>
					);
				} else if (isUrl) {
					return (
						<a
							key={i}
							target={button.buttonLink.target}
							href={button.buttonLink.url}
							title={button.buttonLink.text}
							className={`waves-effect waves-light btn-large ${button.colour != null && button.colour === 'white' ? 'bbwhite' : 'bbred'}`}>
							{button.buttonLink.text}
						</a>
					);
				} else if (isBrochure) {
					return (
						<a
							key={i}
							title={button.brochureAsset.text}
							href={button.brochureAsset.url}
							className={
								button.colour === "red"
									? "waves-effect waves-light btn-large bbred"
									: "waves-effect waves-light btn-large bbwhite"
							}
							download={button.brochureAsset.url}
							target="_blank"
						>
							{button.brochureAsset.text}
						</a>
					);
				}

			})}
		</div>
	);
}

export default HeaderButtons;